import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { entries } from 'lodash'

import { startDateFormatString } from '../../../js/constants'
import './ManningToolTip.scss'

export default class ManningToolTip extends PureComponent {
  static propTypes = {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.number,
    active: PropTypes.bool
  }

  render() {
    if (!this.props.active || !this.props.payload || !this.props.payload.length) {
      return null
    }

    return (
      <div className="custom-tooltip">
        <p className="shift">{moment(this.props.label).format(startDateFormatString)}</p>
        <ul>
          {entries(this.props.payload[0].payload.manningMap).map(([key, value]) => {
            return (
              <li key={key}>
                <span
                  className={`fa ${
                    value.isUnloading ? 'fa-arrow-circle-up' : 'fa-arrow-circle-down'
                  } cargo-type-indicator`}
                  style={{ color: value.color }}
                />
                {key}: {value.manning}
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}
